import HeroHeader from "@/assets/svg/adcelerate/hero.svg";
import Button from "@/components/ui/button";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";

import scrollTo from "@/utils/scrollTo";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <div className="bg-[linear-gradient(to_bottom,var(--primary),var(--tertiary))]">
      <div className="bounce-up p-6 md:p-16 pt-24 md:pt-28 lg:pt-24 flex flex-col lg:flex-row justify-between items-center gap-6 lg:gap-20 h-screen 4xl:h-[70vh] relative overflow-hidden 4xl:max-w-[100rem] 4xl:mx-auto">
        <div className="lg:w-[45%] xl:w-[60%] 1xl:w-[80%] 4xl:w-[50%] space-y-4 xl:space-y-6">
          <h1 className="bounce-up text-4xl sm:text-5xl md:text-7xl lg:text-5xl xl:text-7xl 1xl:text-8xl font-bold text-center lg:text-left text-white adce-hero tracking-wide">
            ACCELERATE YOUR GROWTH
          </h1>
          <p className="bounce-up text-white mg:text-lg leading-6 transition-all duration-700 ease-out text-center lg:text-left lg:max-w-xl pt-3">
            Adcelerate supercharges your channel and makes sure your content
            shines on every platform, while you focus on creating.
          </p>
          <div className="bounce-up flex flex-col md:flex-row items-center gap-4 pt-4 justify-center lg:justify-start">
            <Button
              className="group relative rounded-md shadow bg-transparent border border-white text-white py-6 w-40 text-base flex items-center justify-center gap-2 overflow-hidden hover:text-primary hover:bg-white"
              onClick={() => scrollTo("how-it-works")}
            >
              <span className="transform transition-transform duration-300 group-hover:translate-x-4">
                Learn more
              </span>
              <ArrowDownRight className="transform transition-transform duration-300 group-hover:-translate-x-24" />
            </Button>

            <Link to="/esign">
              <Button className="group relative rounded-md shadow bg-transparent bg-white text-primary py-6 w-40 text-base flex items-center justify-center gap-2 overflow-hidden hover:text-white hover:bg-primary">
                <span className="transform transition-transform duration-300 group-hover:translate-x-5">
                  Access Now
                </span>
                <ArrowUpRight className="transform transition-transform duration-300 group-hover:-translate-x-[100px]" />
              </Button>
            </Link>
          </div>
        </div>
        <img
          src={HeroHeader}
          alt="Image"
          className="lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:-right-44 xl:-right-32 max-w-[670px] ml-20 lg:ml-0"
        />
      </div>
    </div>
  );
}
